import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "../landing/SectionHeading";

/**
 * Compact Fund Architecture teaser for the tightened v2 homepage.
 * Single 9-vehicle strip with family chips + one cross-link to /funds.
 * Replaces the full FundArchitecture section on v2 (full table lives at /funds).
 */
const VEHICLES = [
  { name: "KR Credit Opportunities Fund", family: "Fund", mandate: "Industrial Credit" },
  { name: "KR Special Situations Fund I", family: "Fund", mandate: "Bridge & Special Situations" },
  { name: "KR Strategic Equity Fund I", family: "Fund", mandate: "Opportunistic Equity" },
  { name: "KR Real Estate Credit Fund I", family: "Fund", mandate: "Real Estate Credit" },
  { name: "KR Real Assets Fund I", family: "Fund", mandate: "Real Assets · Industrial" },
  { name: "KR Infrastructure Fund I", family: "Fund", mandate: "Industrial Infrastructure" },
  { name: "KR Co-Investment Vehicles", family: "Capital Channel", mandate: "Cross-Mandate" },
  { name: "KR Debt Solutions", family: "Business Line", mandate: "Bespoke Credit" },
  { name: "KR Strategic Accounts", family: "SMA", mandate: "Single-Investor" },
];

const FundArchTeaser = () => {
  return (
    <section
      id="funds"
      data-testid="kr-v2-funds-teaser"
      className="relative py-32 lg:py-40 border-t border-[var(--kr-line-soft)]"
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-end mb-14">
          <div className="lg:col-span-8">
            <SectionHeading
              index="04"
              label="Fund Architecture"
              title={
                <>
                  Nine vehicles.{" "}
                  <span className="italic text-[var(--kr-gold)]">Four structures.</span>{" "}
                  One platform.
                </>
              }
            />
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <Link
              to="/funds"
              data-testid="kr-v2-funds-cta"
              className="kr-link font-mono-label text-[11px]"
            >
              Full Fund Architecture →
            </Link>
          </div>
        </div>

        <p className="text-[var(--kr-text-muted)] text-[16px] leading-[1.85] max-w-[78ch] mb-12">
          Calibrated to the cash-flow profile, duration and governance preferences of
          sophisticated institutional capital. Vehicle names are working titles; the
          platform&apos;s funds are intended to be domiciled in the Cayman Islands.
        </p>

        <ul className="border-t border-[var(--kr-line)]">
          {VEHICLES.map((v, i) => (
            <li
              key={v.name}
              data-testid={`kr-v2-vehicle-${i}`}
              className="grid lg:grid-cols-12 gap-4 py-5 border-b border-[var(--kr-line)] group hover:bg-[rgba(201,169,110,0.03)] transition-colors duration-500 items-baseline"
            >
              <div className="lg:col-span-1 font-mono-label text-[10px] text-[var(--kr-gold)]">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="lg:col-span-5 font-serif-display text-[var(--kr-text)] text-[1.2rem] leading-[1.25] group-hover:text-[var(--kr-gold)] transition-colors duration-500">
                {v.name}
              </div>
              <div className="lg:col-span-3 font-mono-label text-[10px] text-[var(--kr-text-muted)]">
                {v.family}
              </div>
              <div className="lg:col-span-3 font-mono-label text-[10px] text-[var(--kr-gold)]">
                {v.mandate}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FundArchTeaser;
